import React, { useState, useEffect } from "react";
import CheckIcon from '@mui/icons-material/Check';
 
import { useStyles } from "./styles";

export default function useCopyLinkButton (props) {
    const {
        inProgress,
        copyLabel = 'Copy',
        copiedLabel = 'Copied',
    } = props;

    const classes = useStyles();

    const getCopyButtonLabel = () => {
        return (
            <React.Fragment>
                { copyLabel }
            </React.Fragment>
        );
    }

    const getCopiedButtonLabel = () => {
        return (
            <React.Fragment>
                <CheckIcon
                    className={classes.copiedIcon}
                />
                &nbsp;
                { copiedLabel }
            </React.Fragment>
        );
    }

    const [buttonLabel, setButtonLabel] = useState(getCopyButtonLabel());
    const [showIcon, setShowIcon] = useState(true);

    useEffect(() => {
        if (inProgress) {
            setButtonLabel(getCopiedButtonLabel());
            setShowIcon(false);
        } else {
            setButtonLabel(getCopyButtonLabel());
            setShowIcon(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inProgress]);

    return {
        buttonLabel,
        showIcon,
    };
}